<app-banner>
    <form class="public-page-forms" [formGroup]="resetConfirmForm" (ngSubmit)="onSubmit()">
        <h1 class="form-title text-primary" i18n="@@resetPasswordConfirm.choosePassword">Kies een nieuw wachtwoord</h1>
        <div class="input-container">
            <label for="emailInput" i18n="@@email">E-mailadres</label>
            <input id="emailInput" type="email" formControlName="email" class="text-input" />
        </div>
        <div class="input-container">
            <label for="inputPassword1" class="text-input-label" i18n="@@register.password">Wachtwoord*</label>
            <input id="inputPassword1" type="password" formControlName="newPassword1" class="input" required />
            @if (resetConfirmForm.controls.newPassword1.touched && resetConfirmForm.controls.newPassword1.errors?.required) {
                <div class="error-text" i18n="@@error.required">Dit veld is verplicht.</div>
            }
            @if (resetConfirmForm.controls.newPassword1.touched && resetConfirmForm.controls.newPassword1.errors?.minlength) {
                <div class="error-text" i18n="@@register.error.minlength"
                    >Het wachtwoord moet minstens {{ minPasswordLength }} tekens lang zijn</div
                >
            }
            @if (
                resetConfirmForm.controls.newPassword1.touched &&
                resetConfirmForm.controls.newPassword1.errors?.passwordStrength?.hasUpperCase === false
            ) {
                <div s class="error-text" i18n="@@register.error.hasUpperCase">Het wachtwoord moet hoofdletters bevatten</div>
            }
            @if (
                resetConfirmForm.controls.newPassword1.touched &&
                resetConfirmForm.controls.newPassword1.errors?.passwordStrength?.hasLowerCase === false
            ) {
                <div s class="error-text" i18n="@@register.error.hasLowerCase">Het wachtwoord moet kleine letters bevatten</div>
            }
            @if (
                resetConfirmForm.controls.newPassword1.touched &&
                resetConfirmForm.controls.newPassword1.errors?.passwordStrength?.hasNumeric === false
            ) {
                <div s class="error-text" i18n="@@register.error.hasNumeric">Het wachtwoord moet cijfers bevatten</div>
            }
            @if (
                resetConfirmForm.controls.newPassword1.touched &&
                resetConfirmForm.controls.newPassword1.errors?.passwordStrength?.hasSpecial === false
            ) {
                <div s class="error-text" i18n="@@register.error.hasSpecial"
                    >Het wachtwoord moet bijzondere tekens bevatten ({{ specialCharacters | join: ', ' }})</div
                >
            }
        </div>
        <div class="input-container">
            <label for="inputPassword2" i18n="@@form.passwordVerification">Wachtwoord opnieuw invoeren*</label>
            <input id="inputPassword2" type="password" formControlName="newPassword2" class="input" required />
            @if (resetConfirmForm.controls.newPassword2.touched && resetConfirmForm.errors?.notEqual) {
                <div class="error-text" i18n="@@register.error.passwordVerification">Wachtwoorden komen niet overeen.</div>
            }
            @if (resetConfirmForm.controls.newPassword2.touched && resetConfirmForm.controls.newPassword2.errors?.required) {
                <div class="error-text" i18n="@@error.required">Dit veld is verplicht.</div>
            }
        </div>
        @if (success) {
            <div class="text-success" i18n="@@resetPasswordConfirm.resetConfirmMessage">Nieuw wachtwoord werd ingesteld.</div>
        }
        <div class="button-row">
            <button type="submit" class="button-primary huge" [disabled]="!resetConfirmForm.valid || busy">
                <ng-container [ngTemplateOutlet]="!busy ? defaultMessage : loading" />
            </button>
        </div>
        <a class="primary-link font-bold" routerLink="/login" i18n="@@public.backToLogin">Terug naar loginpagina</a>
    </form>
</app-banner>

<ng-template #defaultMessage><span i18n="@@resetPasswordConfirm.setNewPassword">Nieuw wachtwoord instellen</span></ng-template>
<ng-template #loading>
    <fa-icon [icon]="loadingIcon" [animation]="'spin'" />
</ng-template>
